var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.$auth.watch.authenticated
        ? _c("v-card-text", { staticClass: "instructions-page content-500" }, [
            _c("h2", { staticClass: "page-title" }, [
              _vm._v("Select your team")
            ]),
            _vm._v(" "),
            _vm.userTeams.length === 0
              ? _c("p", [_vm._v("You are not a member of any teams yet")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$auth.watch.authenticated
              ? _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-radio-group",
                      {
                        attrs: { mandatory: true },
                        model: {
                          value: _vm.teamSelection,
                          callback: function($$v) {
                            _vm.teamSelection = $$v
                          },
                          expression: "teamSelection"
                        }
                      },
                      [
                        _vm._l(_vm.userTeams, function(team, index) {
                          return [
                            _c("v-radio", {
                              key: index,
                              attrs: {
                                label: team.teamName,
                                value: team.teamId,
                                color: "primary"
                              }
                            })
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          disabled:
                            !_vm.userTeams.length || _vm.teamSelection === null
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToTeamHome()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("forward")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Select Team")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("exit_to_app")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Logout")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$auth.watch.authenticated
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "alert--outline",
                  attrs: { icon: "warning", color: "error--text" },
                  model: {
                    value: _vm.accessDenied,
                    callback: function($$v) {
                      _vm.accessDenied = $$v
                    },
                    expression: "accessDenied"
                  }
                },
                [
                  _c("strong", [
                    _vm._v("You must login before you can view this page.")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hero-wrapper" },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        column: "",
                        "align-center": "",
                        "justify-center": ""
                      }
                    },
                    [
                      _c("h1", { staticClass: "hero small-text white--text" }, [
                        _vm._v("RoomReady")
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "hero large-text white--text" }, [
                        _vm._v("Room checks made easy.")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$auth.watch.processing,
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.login()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "custom-button btn__text netid" },
                            [_vm._v("Login with Netid")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = s6hi
// module chunks = 1